import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgVehicleTruck = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M5 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h4v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5Zm13 16v2h-2v-2h2Zm0-2H6v-5.586l1.293 1.293A1 1 0 0 0 8 12h8a1 1 0 0 0 .707-.293L18 10.414V16ZM6 7.586V4h12v3.586L15.586 10H8.414L6 7.586ZM8 18v2H6v-2h2Zm8-4a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1Zm5-8h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1V6ZM2 10h1V6H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Z" />
  )
export default SvgVehicleTruck
